// Contact form: AJAX submit to Web3Forms so the visitor stays on the page.

export function initContactForm(doc = document) {
  const form = doc.getElementById("contact-form")
  if (!form) return

  const status = form.querySelector(".form-status")

  const show = (message) => {
    status.textContent = message
    status.hidden = false
  }

  form.addEventListener("submit", async (event) => {
    event.preventDefault()
    show("Sending…")

    try {
      const response = await fetch(form.action, {
        method: "POST",
        body: new FormData(form),
      })

      if (response.ok) {
        show("Thank you! Your message has been sent. Cedric will contact you shortly.")
        form.reset()
      } else {
        show("Sorry, something went wrong. Please WhatsApp or call us instead.")
      }
    } catch {
      show("Sorry, something went wrong. Please WhatsApp or call us instead.")
    }
  })
}
